/**
 * Operator-form defaults that represent product policy rather than a
 * customer contract. Keep the value in one place so changing the standard
 * goal cannot leave different creation paths suggesting different terms.
 * Cohort- and enrollment-specific values still override this at lock time.
 */
export const DEFAULT_TROPHY_GOAL = 150
